import { Component } from '@angular/core';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-vendor-query-list',
  templateUrl: './vendor-query-list.component.html',
  styleUrl: './vendor-query-list.component.scss'
})
export class VendorQueryListComponent {

  vendorList: any[] = [];
  blackList: any[] = [];
  legalCase: any[] = [];

  selectedVendorList: string[] = [];

  selectedVendor:any [] =[];
  blackListStatus="Blacklisted"
  vendorStatus="APPROVED"
  isBlackListed=false
  isLegalCase=true
  totalRecords: number = 0;
  rows: number = 10;
  public searchTerm: string = '';


  constructor(private vendorService: VendorTsService, private router: Router,private messageService: MessageService) { }


  ngOnInit(): void {
    this.vendorService.getVendorQueryList()
      .then(res => {
        // this.vendorList = result.message;
          this.vendorList=res.message
      })
      .catch(error => {
        console.error('Error in component:', error);
      });
  }

  goToVendorDetails(get_user: string,status:string): void {
    const navigationExtras: NavigationExtras = {
      state: {
        get_user: get_user,
        status:status,
      }
    };
    this.router.navigate(['/view-vendor-details',get_user], navigationExtras);

    // this.router.navigate(['/vendor-detail', businessName]);
  }
  goToChangeRequest(vendorId: string): void {
    this.router.navigate(['/portal/vendor/change-request', vendorId]);
  }

  downloadExcel(): void {
    const formattedData = this.formatDataForExcel(this.vendorList);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const colWidths = this.calculateColumnWidths(formattedData);

     // Set the column widths
     ws['!cols'] = colWidths.map(width => ({ wch: width }));
     XLSX.utils.book_append_sheet(wb, ws, 'VendorList');
     XLSX.writeFile(wb, 'vendor_list.xlsx');
  }

  calculateColumnWidths(data: any[]): number[] {
    const colWidths: number[] = [];
    const keys = Object.keys(data[0]);

    keys.forEach((key, colIndex) => {
        let maxWidth = key.length;
        data.forEach(row => {
            maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
        });
        colWidths[colIndex] = maxWidth + 2;
    });

    return colWidths;
  }


  formatDataForExcel(data: any[]): any[] {

    const formattedData = data.map(vendor => ({
      'Name': vendor.business_name,
      'Approval': vendor.approval_name,
      'Query Date': vendor.query_date,
      'Vendor Query': vendor.vendor_query_remark,
    }));
    return formattedData;
  }
}

